import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Descriptions, Button, Row, Col, Divider, message, Spin } from 'antd';
import { EditOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { studentAPI } from '../../services/api';

const StudentView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStudent = async () => {
      try {
        const response = await studentAPI.getById(id);
        setStudent(response.data.data);
      } catch (error) {
        console.error('获取学生详情失败:', error);
        message.error('获取学生详情失败');
      } finally {
        setLoading(false);
      }
    };

    fetchStudent();
  }, [id]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!student) {
    return (
      <Card>
        <div style={{ textAlign: 'center' }}>
          <h3>未找到学生信息</h3>
          <Button type="primary" onClick={() => navigate('/students')}>
            返回列表
          </Button>
        </div>
      </Card>
    );
  }

  // 构建班级完整名称
  const className = student.class_name 
    ? (student.grade_name ? `${student.grade_name} ${student.class_name}` : student.class_name) 
    : '-';

  return (
    <Card
      title="学生详细信息"
      extra={
        <div>
          <Button
            type="link"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate('/students')}
            style={{ marginRight: 8 }}
          >
            返回
          </Button>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => navigate(`/students/edit/${student.id}`)}
          >
            编辑
          </Button>
        </div>
      }
    >
      <h3>基本信息</h3>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Descriptions bordered column={3}>
            <Descriptions.Item label="学生姓名">{student.student_name || '-'}</Descriptions.Item>
            <Descriptions.Item label="全国学籍号">{student.student_id || '-'}</Descriptions.Item>
            <Descriptions.Item label="性别">{student.gender || '-'}</Descriptions.Item>
            <Descriptions.Item label="学校名称">{student.school_name || '-'}</Descriptions.Item>
            <Descriptions.Item label="班级">{className}</Descriptions.Item>
            <Descriptions.Item label="民族">{student.ethnicity || '-'}</Descriptions.Item>
            <Descriptions.Item label="身份证件号">{student.id_card || '-'}</Descriptions.Item>
            <Descriptions.Item label="出生日期">{student.birth_date || '-'}</Descriptions.Item>
            <Descriptions.Item label="姓名拼音">{student.pinyin_name || '-'}</Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>

      <Divider />
      <h3>家庭信息</h3>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Descriptions bordered column={3}>
            <Descriptions.Item label="家长姓名1">{student.parent1_name || '-'}</Descriptions.Item>
            <Descriptions.Item label="家长联系电话1">{student.parent1_phone || '-'}</Descriptions.Item>
            <Descriptions.Item label="家庭成员关系">{student.family_relation || '-'}</Descriptions.Item>
            <Descriptions.Item label="家长姓名2">{student.parent2_name || '-'}</Descriptions.Item>
            <Descriptions.Item label="家长联系电话2">{student.parent2_phone || '-'}</Descriptions.Item>
            <Descriptions.Item label="家庭成员工作单位">{student.parent_work_unit || '-'}</Descriptions.Item>
            <Descriptions.Item label="家庭成员身份证件号">{student.parent_id_card || '-'}</Descriptions.Item>
            <Descriptions.Item label="家庭成员是否监护人">{student.is_guardian || '-'}</Descriptions.Item>
            <Descriptions.Item label="家庭成员民族">{student.parent_ethnicity || '-'}</Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>

      <Divider />
      <h3>住址信息</h3>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Descriptions bordered column={2}>
            <Descriptions.Item label="现居住详细地址">{student.current_address || '-'}</Descriptions.Item>
            <Descriptions.Item label="户口所在地具体地址">{student.residence_address || '-'}</Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>

      <Divider />
      <h3>其他信息</h3>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Descriptions bordered column={3}>
            <Descriptions.Item label="曾用名">{student.former_name || '-'}</Descriptions.Item>
            <Descriptions.Item label="政治面貌">{student.political_status || '-'}</Descriptions.Item>
            <Descriptions.Item label="国籍/地区">{student.nationality || '-'}</Descriptions.Item>
            <Descriptions.Item label="身份证件类型">{student.id_card_type || '-'}</Descriptions.Item>
            <Descriptions.Item label="港澳台侨外">{student.hk_mc_tw || '-'}</Descriptions.Item>
            <Descriptions.Item label="是否寄宿生">{student.is_boarding || '-'}</Descriptions.Item>
            <Descriptions.Item label="是否进城务工人员随迁子女">{student.is_migrant_worker || '-'}</Descriptions.Item>
            <Descriptions.Item label="是否农村留守儿童">{student.is_left_behind || '-'}</Descriptions.Item>
            <Descriptions.Item label="是否残疾人">{student.is_disabled || '-'}</Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
    </Card>
  );
};

export default StudentView; 